<template>
  <div class="basic">
    <div class="basic-task">
      <div
        v-for="(item, index) in taskList"
        :key="index"
        class="task-one"
        :class="item.process ? 'finished' : index === 0 ? 'ing' : ''"
      >
        {{ index + 1 }}.{{ item.nameEn }}
        <div class="box">
          <div v-if="!item.process"></div>
          <i v-else class="icon iconfont icon-duigou" style="color: #fff"></i>
        </div>
      </div>
      <!-- <div class="task-one">
        Done
        <div class="box"><div></div></div>
      </div> -->
      <div class="line"></div>
    </div>
    <Form
      ref="formInline"
      :model="formInline"
      style="width: 100%"
      :rules="ruleInline"
      label-position="top"
      @on-validate="getvalidate"
    >
      <!-- <div style="
          display: flex;
          margin-bottom: 20px;
          position: relative;
          justify-content: center;
        ">
        <span class="req">*</span>
        <Upload ref="upload" :show-upload-list="false" :default-file-list="defaultList5" :on-success="handleSuccess5"
          :format="['pdf']" :max-size="2048" :headers="formHeaders" :on-format-error="handleFormatError5"
          :on-exceeded-size="handleMaxSize5" :before-upload="handleBeforeUpload5" :action="uploadUrl2"
          style="margin-right: 10px">
          <div class="upload-btn" style="
              width: 230px;
              height: 94px;
              border-radius: 4px;
              border: dashed 1px #00bdca;
            ">
            <div style="margin-top: 10px">
              <span class="s-green-color" style="
                  color: #024c8b;
                  margin-bottom: 5px;
                  display: block;
                  font-size: 14px;
                ">Upload Application Form/上传申请表</span>
              <span class="s-green-color" style="font-size: 12px; color: #024c8b; display: block">PDF only, within
                2M/仅支持PDF，不超过2M</span>
            </div>
          </div>
        </Upload>

        <div class="license-img">
          <template v-if="uploadList5 && uploadList5.length">
            <div class="license-img-list" v-for="(item, index) in uploadList5" :key="'upload' + index" style="
                width: 230px;
                height: 84px;
                display: flex;
                justify-content: center;
              ">
              <template v-if="item.status === 'finished'">
                {{ item.name }}
                <span class="line"></span>
                <span @click="handleRemoveByArr5(item)" class="s-green-color">Delete/删除</span>
              </template>
            </div>
          </template>
        </div>
        <div class="downLoad" @click="getfile()">
          <a href="javascript:" class="s-green-color"> Download Booth Application Form/点击下载展位申请表</a>
        </div>
      </div> -->
      <div class="basic-header">
        <p>Booth Application/参展申请</p>
        <span></span>
        <p>General Information/基本信息</p>
      </div>

      <!-- 公司名称 -->
      <div class="basic-name">
        <Row :gutter="10">
          <Col span="15">
            <div style="display: flex">
              <FormItem label="">
                <!-- <Input
                  type="text"
                  placeholder="Please enter English name"
                  v-model="formInline.nameEn"
                  style="width: 570px"
                /> -->
              </FormItem>
              <FormItem label="Company Name/公司名称" prop="name" id="name">
                <Input
                  type="text"
                  v-model="formInline.name"
                  placeholder="Please enter Company name/请输入公司名称"
                  style="width: 560px"
                />
              </FormItem>
            </div>
          </Col>
          <Col span="5">
            <FormItem label="Website/公司官网">
              <Input
                type="text"
                placeholder="Please enter Website/请输入公司网址"
                v-model="formInline.website"
                style="width: 270px"
              />
            </FormItem>
            <!-- <div style="display: flex">
              <FormItem
                label="Company Abbreviation"
                prop="shortName"
                id="shortName"
              >
                <Input
                  type="text"
                  placeholder="Please enter shortName"
                  v-model="formInline.shortName"
                  style="width: 450px"
                />
              </FormItem>
            </div> -->
          </Col>
        </Row>
      </div>

      <!-- 公司地址 -->
      <div class="basic-address">
        <Row :gutter="10">
          <Col span="6">
            <FormItem label="Country/公司地址" required>
              <div style="display: flex">
                <FormItem prop="country" id="country">
                  <!-- <Input
                    type="text"
                    placeholder="country"
                    v-model="formInline.country"
                    style="width: 230px; margin-right: 10px"
                  /> -->
                  <Select
                    style="width: 230px"
                    v-if="countryList"
                    v-model="formInline.country"
                    placeholder="Please select your country"
                  >
                    <Option
                      v-for="(item, index) in countryList"
                      :value="item.value"
                      :label="$t(item.value)"
                      :key="index"
                    >
                      {{ item.value }}</Option
                    >
                  </Select>
                </FormItem>
                <!-- <FormItem prop="province" id="province">

                  <Select
                    v-model="formInline.province"
                    style="width: 130px; margin-right: 10px"
                    placeholder="省"
                    size="default"
                    @on-change="change1"
                  >
                    <Option
                      v-for="item in cityList1"
                      :value="item.value"
                      :key="item.value"
                      >{{ item.value }}</Option
                    >
                  </Select>
                </FormItem> -->
                <!-- <FormItem prop="city" id="city">

                  <Select
                    v-model="formInline.city"
                    style="width: 130px; margin-right: 10px"
                    placeholder="市"
                    size="default"
                    @on-change="change2"
                  >
                    <Option
                      v-for="item in cityList2"
                      :value="item.value"
                      :key="item.value"
                      >{{ item.value }}</Option
                    >
                  </Select>
                </FormItem>
                <FormItem prop="county" id="county">

                  <Select
                    v-model="formInline.county"
                    style="width: 130px; margin-right: 10px"
                    placeholder="县/区"
                    size="default"
                    @on-change="change3"
                  >
                    <Option
                      v-for="item in cityList3"
                      :value="item.value"
                      :key="item.value"
                      >{{ item.value }}</Option
                    >
                  </Select>
                </FormItem> -->
              </div>
            </FormItem>
          </Col>

          <Col span="18">
            <div style="display: flex">
              <FormItem
                prop="address"
                id="address"
                label="Company Address/详细地址"
                required
              >
                <Input
                  type="text"
                  placeholder="Please enter Company Address/请输入详细地址"
                  v-model="formInline.address"
                  style="width: 565px; margin-right: 50px"
                />
              </FormItem>
              <FormItem prop="postcode" id="postcode" label="Postcode/邮编">
                <Input
                  type="text"
                  placeholder="Please enter postcode/请输入邮编"
                  v-model="formInline.postcode"
                  style="width: 230px"
                />
              </FormItem>
            </div>
          </Col>
        </Row>
      </div>

      <!-- 公司电话 -->
      <div class="basic-phone">
        <Row :gutter="10">
          <Col span="12">
            <div style="display: flex">
              <FormItem label="Telephone/电话" prop="telephone" id="telephone">
                <Input
                  type="text"
                  placeholder="Please enter Telephone/请输入公司电话"
                  v-model="formInline.telephone"
                  style="width: 270px; margin-right: 10px"
                />
                <p
                  style="
                    line-height: 1;
                    font-size: 12px;
                    color: #808080;
                    margin-top: 6px;
                  "
                >
                  Examples/示例:+86-10-84666617
                </p>
              </FormItem>
            </div>
          </Col>
          <Col span="12">
            <div style="display: flex">
              <FormItem
                label="Asset Type/资产类型"
                prop="typeAsset"
                id="typeAsset"
              >
                <Select
                  v-model="formInline.typeAsset"
                  style="width: 270px; margin-right: 10px"
                  @on-change="getselect"
                  placeholder="Please select Asset Type/请选择资产类型"
                >
                  <Option
                    v-for="item in BusinessList"
                    :value="item.nameEn + '/' + item.name"
                    :key="item.nameEn + '/' + item.name"
                    >{{ item.nameEn }}/{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
              <FormItem
                label="Business Type/企业经营类型"
                prop="typeBusiness"
                id="typeBusiness"
              >
                <Select
                  v-model="formInline.typeBusiness"
                  style="width: 270px"
                  placeholder="Please select your business type/请选择企业经营类型"
                  v-if="isOption"
                >
                  <Option
                    v-for="item in NatureList"
                    :value="item.nameEn + '/' + item.name"
                    :key="item.nameEn + '/' + item.name"
                  >
                    {{ item.nameEn }}/{{ item.name }}</Option
                  >
                </Select>
                <Input
                  v-else
                  placeholder="Please enter Business Type/请输入企业经营类型"
                  v-model="formInline.typeBusiness"
                  style="width: 270px"
                ></Input>
              </FormItem>
            </div>
          </Col>
        </Row>
      </div>

      <!-- 营业执照 -->
      <div class="basic-license">
        <Row :gutter="10">
          <Col span="12">
            <FormItem
              label="Company registration certificate/营业执照"
              required
            >
              <div style="display: flex; position: relative">
                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :default-file-list="defaultList"
                  :on-success="handleSuccess"
                  :format="['jpg', 'png']"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  :action="uploadUrl"
                  style="margin-right: 10px"
                >
                  <div class="upload-btn">Upload Registration/上传营业执照</div>
                </Upload>
                <p
                  style="
                    position: absolute;
                    left: 0;
                    top: 34px;
                    font-size: 12px;
                    color: #808080;
                  "
                >
                  jpg,png only, within 2M
                </p>
                <div class="license-img">
                  <template v-if="uploadList && uploadList.length">
                    <div
                      class="license-img-list"
                      v-for="(item, index) in uploadList"
                      :key="'upload' + index"
                    >
                      <template v-if="item.status === 'finished'">
                        {{ item.name }}
                        <span class="line"></span>
                        <span @click="handleRemoveByArr(item)">Delete</span>
                      </template>
                    </div>
                  </template>
                </div>
              </div>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="Company Logo/公司logo" required>
              <div style="display: flex; position: relative">
                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :default-file-list="defaultList2"
                  :on-success="handleSuccess2"
                  :format="['jpg', 'png']"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError2"
                  :on-exceeded-size="handleMaxSize2"
                  :before-upload="handleBeforeUpload2"
                  :action="uploadUrl"
                  style="margin-right: 10px"
                >
                  <div class="upload-btn">Upload Company Logo/上传公司logo</div>
                </Upload>
                <p
                  style="
                    position: absolute;
                    left: 0;
                    top: 34px;
                    font-size: 12px;
                    color: #808080;
                  "
                >
                  jpg,png only, within 2M
                </p>
                <div class="license-img">
                  <template v-if="uploadList2 && uploadList2.length">
                    <div
                      class="license-img-list"
                      v-for="(item, index) in uploadList2"
                      :key="'upload' + index"
                    >
                      <template v-if="item.status === 'finished'">
                        {{ item.name }}
                        <span class="line"></span>
                        <span @click="handleRemoveByArr2(item)">Delete</span>
                      </template>
                    </div>
                  </template>
                </div>
              </div>
            </FormItem>
          </Col>
        </Row>
      </div>

      <!-- 企业类型 -->
      <div class="basic-export">
        <Row :gutter="10">
          <Col span="12">
            <!-- <FormItem label="Whether to export the enterprise" >
              <div style="display: flex; flex-wrap: wrap">
                <iSwitch
                  size="large"
                  style="margin-right: 14px; margin-top: 4px"
                  v-model="isExport"
                >
                  <span slot="open">Yes</span>
                  <span slot="close">No</span>
                </iSwitch>
                <div v-if="isExport">
                  <Row
                    v-for="(item, index) in formInline.exportSalesArea"
                    :key="'cityInfo-' + index"
                    style="width: 480px; margin-bottom: 5px"
                  >
                    <Col span="22">
                      <Cascader
                        v-model="formInline.exportSalesArea[index]"
                        :data="AreaList"
                        :load-data="loadData"
                        style="width: 440px; margin-right: 10px"
                        placeholder="Yes: Select your country and region"
                        :key="'exportSalesArea-' + index"
                      ></Cascader>
                    </Col>
                    <Col span="2" class="ie-icon" style="text-align: center">
                      <Icon
                        type="ios-add-circle-outline"
                        v-if="index === 0"
                        @click="addAreaArr()"
                        style="color: #2d8cf0; font-size: 20px; cursor: pointer"
                      />
                      <Icon
                        type="ios-remove-circle-outline"
                        v-else
                        style="color: red; font-size: 20px; cursor: pointer"
                        @click="delAreaArr(index)"
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </FormItem> -->
            <FormItem
              label="Whether Fortune Global 500/是否隶属于世界500强"
              required
            >
              <iSwitch
                size="large"
                @on-change="topNoChange"
                style="margin-right: 14px"
                v-model="isTop500"
              >
                <span slot="open">Yes</span>
                <span slot="close">No</span>
              </iSwitch>
              <Input
                v-if="isTop500"
                type="text"
                placeholder="Please enter ranking/请输入排名"
                v-model="formInline.topNo"
                style="width: 480px"
              />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="Whether Listed Company/是否上市公司" required>
              <iSwitch
                size="large"
                @on-change="listedChange"
                style="margin-right: 14px"
                v-model="isListed"
              >
                <span slot="open">Yes</span>
                <span slot="close">No</span>
              </iSwitch>
              <template v-if="isListed">
                <Input
                  type="text"
                  placeholder="Please enter securities exchange/请输入证券交易所"
                  v-model="formInline.stockExchange"
                  style="width: 235px; margin-right: 10px"
                />
                <Input
                  type="text"
                  placeholder="Please enter stock ticker/请输入股票代码"
                  v-model="formInline.stockCode"
                  style="width: 235px"
                />
              </template>
            </FormItem>
          </Col>
        </Row>
      </div>

      <!-- 企业规模 -->
      <!-- <div class="basic-scale">
        <Row :gutter="10"> -->
      <!-- <Col span="12"> </Col> -->
      <!-- <Col span="12">
            <FormItem label="是否为小微企业" required>
              <div style="display: flex">
                <iSwitch
                  size="large"
                  style="margin-right: 14px; margin-top: 5px"
                  v-model="isMicroEnterprise"
                >
                  <span slot="open">是</span>
                  <span slot="close">否</span>
                </iSwitch>
                <template v-if="isMicroEnterprise">
                  <div style="display: flex; position: relative; flex: 1">
                    <Upload
                      ref="upload"
                      :show-upload-list="false"
                      :default-file-list="defaultList3"
                      :on-success="handleSuccess3"
                      :format="['jpg', 'png']"
                      :max-size="2048"
                      :headers="formHeaders"
                      :on-format-error="handleFormatError3"
                      :on-exceeded-size="handleMaxSize3"
                      :before-upload="handleBeforeUpload3"
                      :action="uploadUrl"
                      style="margin-right: 10px"
                    >
                      <div class="upload-btn">上传小微企业证明</div>
                    </Upload>
                    <p
                      style="
                        position: absolute;
                        left: 0;
                        top: 34px;
                        font-size: 12px;
                        color: #808080;
                      "
                    >
                      仅支持jpg,png，不超过2M
                    </p>
                    <div class="license-img">
                      <template v-if="uploadList3 && uploadList3.length">
                        <div
                          class="license-img-list"
                          v-for="(item, index) in uploadList3"
                          :key="'upload' + index"
                        >
                          <template v-if="item.status === 'finished'">
                            {{ item.name }}
                            <span class="line"></span>
                            <span @click="handleRemoveByArr3(item)">删除</span>
                          </template>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
            </FormItem>
          </Col> -->
      <!-- </Row>
      </div> -->

      <!-- 高新技术 -->
      <!-- <div class="basic-tech">
        <FormItem label="是否为高新技术企业" required>
          <div style="display: flex">
            <iSwitch
              size="large"
              style="margin-right: 14px; margin-top: 5px"
              v-model="isHighTech"
            >
              <span slot="open">是</span>
              <span slot="close">否</span>
            </iSwitch>
            <template v-if="isHighTech">
              <div style="display: flex; position: relative; flex: 1">
                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :default-file-list="defaultList4"
                  :on-success="handleSuccess4"
                  :format="['jpg', 'png']"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError4"
                  :on-exceeded-size="handleMaxSize4"
                  :before-upload="handleBeforeUpload4"
                  :action="uploadUrl"
                  style="margin-right: 10px"
                >
                  <div
                    class="upload-btn"
                    style="width: 180px; background-color: #f5f5f5"
                  >
                    上传高新技术企业
                  </div>
                </Upload>
                <p
                  style="
                    position: absolute;
                    left: 0;
                    top: 34px;
                    font-size: 12px;
                    color: #808080;
                  "
                >
                  仅支持jpg,png，不超过2M
                </p>
                <div class="license-img">
                  <template v-if="uploadList4 && uploadList4.length">
                    <div
                      class="license-img-list"
                      v-for="(item, index) in uploadList4"
                      :key="'upload' + index"
                      style="background-color: #f5f5f5"
                    >
                      <template v-if="item.status === 'finished'">
                        {{ item.name }}
                        <span class="line"></span>
                        <span @click="handleRemoveByArr4(item)">删除</span>
                      </template>
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </FormItem>
      </div> -->

      <!-- 展会联系人 -->
      <div class="basic-link">
        <FormItem label="Contact Person/展会联系人" required> </FormItem>
      </div>
      <div class="basic-links">
        <Row :gutter="10">
          <Col span="12">
            <div style="display: flex">
              <FormItem label=" Name/姓名" prop="linkMan" id="linkMan">
                <Input
                  type="text"
                  placeholder="Please enter Name/请输入姓名"
                  v-model="formInline.linkMan"
                  style="width: 270px; margin-right: 10px"
                />
              </FormItem>
              <FormItem label="Position/职务" prop="linkTitle" id="linkTitle">
                <Input
                  type="text"
                  placeholder="Please enter Position/请输入职务"
                  v-model="formInline.linkTitle"
                  style="width: 270px"
                />
              </FormItem>
            </div>
          </Col>
          <Col span="12">
            <div style="display: flex">
              <FormItem label="contact number/手机" prop="linkMob" id="linkMob">
                <Input
                  type="text"
                  placeholder="Please enter contact number/请输入手机号"
                  v-model="formInline.linkMob"
                  style="width: 270px; margin-right: 10px"
                />
              </FormItem>
              <FormItem label="Email/邮箱" prop="linkEmail" id="linkEmail">
                <Input
                  type="text"
                  placeholder="Please enter Email/请输入邮箱"
                  v-model="formInline.linkEmail"
                  style="width: 270px"
                />
              </FormItem>
            </div>
          </Col>
        </Row>
        <Row :gutter="10">
          <!-- <Col span="12">
            <FormItem label="电话" required>
              <div style="display: flex">
                <FormItem>
                  <Input
                    type="text"
                    v-model="formInline.linkTelephone1"
                    style="width: 130px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem>
                  <Input
                    type="text"
                    v-model="formInline.linkTelephone2"
                    style="width: 130px; margin-right: 10px"
                  />
                </FormItem>
              </div>
            </FormItem>
          </Col> -->
          <!-- <Col span="12">
            <FormItem label="传真">
              <div style="display: flex">
                <FormItem>
                  <Input
                    type="text"
                    v-model="formInline.linkFax1"
                    style="width: 130px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem>
                  <Input
                    type="text"
                    v-model="formInline.linkFax2"
                    style="width: 130px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem>
                  <Input
                    type="text"
                    v-model="formInline.linkFax3"
                    style="width: 270px"
                  />
                </FormItem>
              </div>
            </FormItem>
          </Col> -->
        </Row>
      </div>

      <!-- 市场部负责人 -->
      <div class="basic-leader">
        <FormItem label="Marketing Personnel/市场部负责人" required> </FormItem>
        <Button @click="ditto" class="above">Same as above/信息同步</Button>
      </div>
      <div class="basic-leaders">
        <Row :gutter="10">
          <Col span="12">
            <div style="display: flex">
              <FormItem label="Name/姓名" prop="leader" id="leader">
                <Input
                  type="text"
                  placeholder="Please enter Name/请输入姓名"
                  v-model="formInline.leader"
                  style="width: 270px; margin-right: 10px"
                />
              </FormItem>
              <FormItem
                label="Position/职务"
                prop="leaderTitle"
                id="leaderTitle"
              >
                <Input
                  type="text"
                  placeholder="Please enter Position/请输入职务"
                  v-model="formInline.leaderTitle"
                  style="width: 270px"
                />
              </FormItem>
            </div>
          </Col>
          <Col span="12">
            <div style="display: flex">
              <FormItem
                label="contact number/手机"
                prop="leaderMob"
                id="leaderMob"
              >
                <Input
                  type="text"
                  placeholder="Please enter contact number/请输入手机号"
                  v-model="formInline.leaderMob"
                  style="width: 270px; margin-right: 10px"
                />
              </FormItem>
              <FormItem label="Email/邮箱" prop="leaderEmail" id="leaderEmail">
                <Input
                  type="text"
                  placeholder="Please enter Email/请输入邮箱"
                  v-model="formInline.leaderEmail"
                  style="width: 270px"
                />
              </FormItem>
            </div>
          </Col>
        </Row>
        <Row :gutter="10">
          <!-- <Col span="12">
            <FormItem label="电话" required>
              <div style="display: flex">
                <FormItem>
                  <Input
                    type="text"
                    v-model="formInline.leaderTelephone1"
                    style="width: 130px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem>
                  <Input
                    type="text"
                    v-model="formInline.leaderTelephone2"
                    style="width: 130px; margin-right: 10px"
                  />
                </FormItem>
              </div>
            </FormItem>
          </Col> -->
          <!-- <Col span="12">
            <FormItem label="传真">
              <div style="display: flex">
                <FormItem>
                  <Input
                    type="text"
                    v-model="formInline.leaderFax1"
                    style="width: 130px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem>
                  <Input
                    type="text"
                    v-model="formInline.leaderFax2"
                    style="width: 130px; margin-right: 10px"
                  />
                </FormItem>
                <FormItem>
                  <Input
                    type="text"
                    v-model="formInline.leaderFax3"
                    style="width: 270px"
                  />
                </FormItem>
              </div>
            </FormItem>
          </Col> -->
        </Row>
      </div>

      <!-- 开票信息 -->
      <div class="basic-invoiceType">
        <p>VAT Invoice(中国增值税发票)</p>
        <Checkbox v-model="isInvoice"><span>无开票信息</span></Checkbox>
      </div>
      <div class="basic-invoices" v-if="!isInvoice">
        <Row :gutter="10">
          <Col span="12">
            <div style="display: flex">
              <FormItem label="发票抬头" prop="invoiceTitle" id="invoiceTitle">
                <Input
                  type="text"
                  placeholder="请输入发票抬头"
                  v-model="formInline.invoiceTitle"
                  style="width: 270px; margin-right: 10px"
                />
              </FormItem>
              <FormItem label="税号" prop="invoiceCode" id="invoiceCode">
                <Input
                  type="text"
                  placeholder="请输入税号"
                  v-model="formInline.invoiceCode"
                  style="width: 270px"
                />
              </FormItem>
            </div>
          </Col>
          <Col span="12">
            <div style="display: flex">
              <FormItem
                label="请输入单位地址"
                prop="invoiceAddress"
                id="invoiceAddress"
              >
                <Input
                  type="text"
                  placeholder="请输入单位地址"
                  v-model="formInline.invoiceAddress"
                  style="width: 270px; margin-right: 10px"
                />
              </FormItem>
              <FormItem
                label="电话号码"
                prop="invoiceTelephone"
                id="invoiceTelephone"
              >
                <Input
                  type="text"
                  placeholder="请输入电话号码"
                  v-model="formInline.invoiceTelephone"
                  style="width: 270px"
                />
              </FormItem>
            </div>
          </Col>
        </Row>
        <Row :gutter="10">
          <Col span="12">
            <div style="display: flex">
              <FormItem label="开户银行" prop="invoiceBank" id="invoiceBank">
                <Input
                  type="text"
                  v-model="formInline.invoiceBank"
                  style="width: 270px; margin-right: 10px"
                  placeholder="请输入开户银行"
                />
              </FormItem>
              <FormItem
                label="银行账户"
                prop="invoiceBankAccount"
                id="invoiceBankAccount"
              >
                <Input
                  type="text"
                  v-model="formInline.invoiceBankAccount"
                  placeholder="请输入银行账户"
                  style="width: 270px"
                />
              </FormItem>
            </div>
          </Col>
          <Col span="12">
            <div style="display: flex">
              <FormItem label="开票类型" prop="invoiceType" id="invoiceType">
                <RadioGroup
                  v-model="formInline.invoiceType"
                  @on-change="changeInvoice"
                >
                  <Radio label="增值税专票">
                    <span>专票</span>
                  </Radio>
                  <Radio label="增值税普票">
                    <span>普票</span>
                  </Radio>
                </RadioGroup>
              </FormItem>
            </div>
          </Col>
        </Row>
        <Row :gutter="10">
          <Col span="12">
            <div style="display: flex">
              <FormItem label="邮寄地址" prop="PostAddr" id="PostAddr">
                <Input
                  type="text"
                  v-model="formInline.PostAddr"
                  style="width: 270px; margin-right: 10px"
                  placeholder="请输入邮寄地址"
                />
              </FormItem>
              <FormItem label="联系人" prop="PostMan" id="PostMan">
                <Input
                  type="text"
                  v-model="formInline.PostMan"
                  style="width: 270px"
                  placeholder="请输入联系人"
                />
              </FormItem>
            </div>
          </Col>
          <Col span="12">
            <div style="display: flex">
              <FormItem label="联系电话" prop="PostTel" id="PostTel">
                <Input
                  type="text"
                  v-model="formInline.PostTel"
                  placeholder="请输入联系电话"
                  style="width: 270px"
                />
              </FormItem>
            </div>
          </Col>
        </Row>
      </div>

      <div class="basic-btn">
        <Button
          type="primary"
          size="large"
          @click="handleSubmit('formInline')"
          :loading="loading"
          >Submit and Proceed
          <br />
          提交并下一步</Button
        >
      </div>
    </Form>
  </div>
</template>

<script>
import config from "@assets/config.json";
import { mapGetters, mapActions } from "vuex";
import { validator } from "@/other/validatorEn";
import city from "../../../../../../static/city.json";
export default {
  name: "basic", // 参展申请 - 基本信息
  data() {
    return {
      cityList1: [],
      cityList2: [],
      cityList3: [],
      model0: "",
      model2: "",
      model3: "",
      model1: "",
      sheng: [],
      shi: [],
      qu: [],
      city: city,
      taskList: [],
      speenInfo: null,
      loading: false,
      formInline: {
        name: "",
        nameEn: "",
        shortName: "",
        //creditCode: "",
        country: "",
        //province: "安徽省",
        //city: "11111",
        //county: "22222",
        address: "",
        postcode: "",
        telephone: "",
        website: "",
        typeAsset: "",
        typeBusiness: "",
        //exportSalesArea: [[]],
        stockExchange: "", // 证件交易所
        stockCode: "", // 股票代码
        topNo: "", // 世界排名
        linkMan: "",
        linkTitle: "",
        linkMob: "",
        linkEmail: "",
        //linkTelephone1: "",
        //linkTelephone2: "",
        //linkTelephone3: "",
        // linkFax1: "",
        // linkFax2: "",
        // linkFax3: "",
        leader: "",
        leaderTitle: "",
        leaderMob: "",
        leaderEmail: "",
        // leaderTelephone1: "",
        // leaderTelephone2: "",
        // leaderTelephone3: "",
        // leaderFax1: "",
        // leaderFax2: "",
        // leaderFax3: "",
        invoiceTitle: "",
        invoiceCode: "",
        invoiceAddress: "",
        invoiceTelephone: "",
        invoiceBank: "",
        invoiceBankAccount: "",
        invoiceType: "增值税专票", //发票类型
        FileApplyTable: "",
        PostAddr: "", //发票地址
        PostMan: "", //联系人
        PostTel: "", //联系电话
      },
      ruleInline: {
        name: [
          {
            required: true,
            message: "Please enter Company Name/请输入公司名称",
            trigger: "blur",
          },
        ],
        // shortName: [
        //   { required: true, message: "Please enter公司简称", trigger: "blur" },
        // ],
        // creditCode: [
        //   {
        //     required: true,
        //     message: "统一社会信用代码不能为空",
        //     trigger: "blur",
        //   },
        //   ...validator.CreditCode,
        // ],
        country: [
          {
            required: true,
            message: "Please enter country/请输入国家",
            trigger: "blur",
          },
        ],
        // province: [{ required: true, message: "Please enter省份", trigger: "blur" }],
        // city: [{ required: true, message: "Please enter城市", trigger: "blur" }],
        // county: [{ required: true, message: "Please enter区县", trigger: "blur" }],
        address: [
          {
            required: true,
            message: "Please enter Detail address/请输入详细地址",
            trigger: "blur",
          },
        ],
        //postcode: [{ required: true, message: "Please enter邮编", trigger: "blur" }],
        telephone: [
          {
            required: true,
            message: "Please enter Telephone/请输入电话号",
            trigger: "blur",
          },
        ],
        typeAsset: [
          {
            required: true,
            message: "Please select Asset Type/请选择资产类型",
            trigger: "change",
          },
        ],
        typeBusiness: [
          {
            required: true,
            message: "Please select Business Type/请选择企业经营类型",
            trigger: "change",
          },
        ],
        linkMan: [
          {
            required: true,
            message: "Please enter Name/请输入姓名",
            trigger: "blur",
          },
        ],
        linkTitle: [
          {
            required: true,
            message: "Please enter Position/请输入职务",
            trigger: "blur",
          },
        ],
        linkMob: validator.phone,
        linkEmail: validator.email,
        leader: [
          {
            required: true,
            message: "Please enter Name/请输入姓名",
            trigger: "blur",
          },
        ],
        leaderTitle: [
          {
            required: true,
            message: "Please enter Position/请输入职务",
            trigger: "blur",
          },
        ],
        leaderMob: validator.phone,
        leaderEmail: validator.email,
        invoiceTitle: [
          {
            required: true,
            message: "请输入发票抬头",
            trigger: "blur",
          },
        ],
        invoiceCode: [
          { required: true, message: "请输入税号", trigger: "blur" },
        ],
        invoiceAddress: [
          {
            required: true,
            message: "请输入单位地址",
            trigger: "blur",
          },
        ],
        invoiceTelephone: [
          {
            required: true,
            message: "请输入电话号码",
            trigger: "blur",
          },
        ],
        invoiceBank: [
          {
            required: true,
            message: "请输入开户银行",
            trigger: "blur",
          },
        ],
        invoiceBankAccount: [
          {
            required: true,
            message: "请输入银行账户",
            trigger: "blur",
          },
        ],
        invoiceType: [
          { required: true, message: "请选择开票类型", trigger: "blur" },
        ],
        PostAddr: [
          { required: true, message: "请输入邮编地址", trigger: "blur" },
        ],
        PostMan: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        PostTel: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
      },
      BusinessList: [],
      NatureList: [],
      AreaList: [],
      defaultList: [],
      uploadList: [],
      uploadName: "",

      defaultList2: [],
      uploadList2: [],
      uploadName2: "",

      isExport: true, // 是否是外销企业
      isListed: true, // 是否是上市公司
      isTop500: true, // 是否是世界五百强
      isMicroEnterprise: true, // 是否为小微企业
      isHighTech: true, // 是否为高新技术企业
      isInvoice: false, // 有/无 开票信息

      defaultList3: [],
      uploadList3: [],
      uploadName3: "",

      defaultList4: [],
      uploadList4: [],
      uploadName4: "",

      defaultList5: [],
      uploadList5: [],
      uploadName5: "",
      basicInfo: null,
      validateList: [],
      ElepropName: "", //验证错误的prop名
      companyId: "", //公司ID
      isOption: true, //企业经营类型是否是选择框
      countryList: [], //国家数组
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      formHeaders: "getFormHeaders",
      uploadUrl: "getUploadUrl",
      exhibitionId: "getExhibitionId",
      company: "getCompany",
    }),
    userId() {
      return this.$route.query.userId;
    },

    upDateExId() {
      return this.$route.query.upDateExId;
    },
    applyCompanyId() {
      return this.$route.query.applyCompanyId;
    },
    applyCompanyOrderId() {
      return this.$route.query.applyCompanyOrderId;
    },
    uploadUrl2() {
      return `${config.api.reqApi}/api/upload/files`;
    },
  },
  mounted() {
    var city = this.city;
    for (var i in city) {
      var obj = {
        value: city[i].name,
        id: city[i].id,
      };
      this.cityList1.push(obj);
      this.shi.push(city[i].child);
    }
  },
  methods: {
    ...mapActions({
      getApplyFlow: "getApplyFlow",
      getApplyFlowSpeed: "getApplyFlowSpeed",
      getNature: "getNature",
      getBusinessType: "getBusinessType",
      addApplyCompany: "addApplyCompany",
      editApplyCompany: "editApplyCompany",
      getAreaAll: "getAreaAll",
      getCountryByArea: "getCountryByArea",
      getApplyCompanyBasic: "getApplyCompanyBasic",
      getJoinCompany: "getJoinCompany",
      getYesLink: "getYesLink",
      getApplyConfig: "getApplyConfig", //获取文件
      getwordfileEn: "getwordfileTermEn", //下载文档
      getCountry: "getCountryNew",
      getAllAddress: "getAllAddress",
      getCompanyBasicInfo: "getCompanyBasicInfo", //获取公司申报的信息
    }),
    getvalidate(prop, status, error) {
      if (status == false) {
        console.log(prop, "prop", status, "status", error, "error");
        let opt = {
          prop: prop,
          status: status,
        };
        this.validateList.push(opt);
      }
    },
    deteleObject(obj) {
      var uniques = [];
      var stringify = {};
      for (var i = 0; i < obj.length; i++) {
        var keys = Object.keys(obj[i]);
        keys.sort(function (a, b) {
          return Number(a) - Number(b);
        });
        var str = "";
        for (var j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
        }
      }
      uniques = uniques;
      return uniques;
    },
    async init() {
      // 流程
      let taskList = await this.getApplyFlow();
      this.taskList = taskList;
      //获取国家json
      let arr = await this.getCountry();
      console.log(arr);
      for (let i = 0; i < arr.length; i++) {
        let obj = {};
        obj.value = arr[i].name + "/" + arr[i].pinyin;
        obj.lable = arr[i].name + "/" + arr[i].pinyin;
        this.countryList.push(obj);
      }
      // 申请中的
      if (this.applyCompanyId) {
        let info = await this.getApplyFlowSpeed(this.applyCompanyId);
        if (info && info.info) {
          this.speenInfo = info.info;
          if (this.taskList && this.taskList.length > 0) {
            this.taskList.map((c) => {
              if (this.speenInfo && this.speenInfo.speed >= c.speed) {
                c.process = true;
              }
            });
          }
        }

        //获取基本信息
        let basicInfo = await this.getApplyCompanyBasic(this.applyCompanyId);
        this.basicInfo = basicInfo;
        // console.log("基本信息：",this.basicInfo);
        if (basicInfo) {
          this.formInline.name = basicInfo.companyName;
          this.formInline.nameEn = basicInfo.companyNameEn;
          this.formInline.shortName = basicInfo.companyNameShort;
          //this.formInline.creditCode = basicInfo.unifiedCode;
          this.formInline.country = basicInfo.country;
          //   this.formInline.province = basicInfo.province;
          //   this.formInline.city = basicInfo.city;
          //   this.formInline.county = basicInfo.county;
          this.formInline.address = basicInfo.address;
          this.formInline.postcode = basicInfo.postcode;
          this.formInline.telephone = basicInfo.telephone;
          this.formInline.website = basicInfo.website;
          this.formInline.typeAsset = basicInfo.typeAsset;
          this.formInline.typeBusiness = basicInfo.typeBusiness;
          let imgBusinessLicense = JSON.parse(basicInfo.imgBusinessLicense);
          let fileApplyTable = JSON.parse(basicInfo.fileApplyTable);
          //   this.change1(this.formInline.province);
          //   this.change2(this.formInline.city);
          //   this.change3(this.formInline.county);
          if (fileApplyTable && fileApplyTable.url) {
            this.uploadList5.push(fileApplyTable);
          }
          if (imgBusinessLicense && imgBusinessLicense.url) {
            this.uploadList.push(imgBusinessLicense);
          }
          let imgLogo = JSON.parse(basicInfo.imgLogo);
          if (imgLogo && imgLogo.url) {
            this.uploadList2.push(imgLogo);
          }
          if (basicInfo.isExportSales === "false") {
            this.isExport = false;
          } else {
            this.isExport = true;
          }
          //   if (basicInfo.exportSalesCountry) {
          //     let exportSalesCountry = JSON.parse(basicInfo.exportSalesCountry);
          //     this.formInline.exportSalesArea = exportSalesCountry;
          //   }

          if (basicInfo.isListed === "false") {
            this.isListed = false;
          } else {
            this.isListed = true;
          }
          this.formInline.stockExchange = basicInfo.listedExchange;
          this.formInline.stockCode = basicInfo.listedCode;

          if (basicInfo.isTop500 === "false") {
            this.isTop500 = false;
          } else {
            this.isTop500 = true;
          }
          this.formInline.topNo = basicInfo.topNo;

          if (basicInfo.isMicroEnterprise === "false") {
            this.isMicroEnterprise = false;
          } else {
            this.isMicroEnterprise = true;
          }
          //   if (basicInfo.imgMicroEnterprise) {
          //     let imgMicroEnterprise = JSON.parse(basicInfo.imgMicroEnterprise);
          //     if (imgMicroEnterprise.length > 0) {
          //       imgMicroEnterprise.map((c) => {
          //         this.uploadList3.push(c);
          //       });
          //     }
          //   }

          if (basicInfo.isHighTech === "false") {
            this.isHighTech = false;
          } else {
            this.isHighTech = true;
          }
          //   if (basicInfo.imgHighTech) {
          //     let imgHighTech = JSON.parse(basicInfo.imgHighTech);
          //     if (imgHighTech.length > 0) {
          //       imgHighTech.map((c) => {
          //         this.uploadList4.push(c);
          //       });
          //     }
          //   }

          this.formInline.linkMan = basicInfo.linkMan;
          this.formInline.linkTitle = basicInfo.linkTitle;
          this.formInline.linkMob = basicInfo.linkMob;
          this.formInline.linkEmail = basicInfo.linkEmail;
          //   let linkTelephone = basicInfo.linkTelephone.split("-");
          //     if (linkTelephone[0]) {
          //       this.formInline.linkTelephone1 = linkTelephone[0];
          //     }
          //   if (linkTelephone[1]) {
          //     this.formInline.linkTelephone2 = linkTelephone[1];
          //   }
          //   if (linkTelephone[2]) {
          //     this.formInline.linkTelephone3 = linkTelephone[2];
          //   }
          //let linkFax = basicInfo.linkFax.split("-");
          //   if (linkFax[0]) {
          //     this.formInline.linkFax1 = linkFax[0];
          //   }
          //   if (linkFax[1]) {
          //     this.formInline.linkFax2 = linkFax[1];
          //   }
          //   if (linkFax[2]) {
          //     this.formInline.linkFax3 = linkFax[2];
          //   }
          this.formInline.leader = basicInfo.leader;
          this.formInline.leaderTitle = basicInfo.leaderTitle;
          this.formInline.leaderMob = basicInfo.leaderMob;
          this.formInline.leaderEmail = basicInfo.leaderEmail;
          //let leaderTelephone = basicInfo.leaderTelephone.split("-");
          //   if (leaderTelephone[0]) {
          //     this.formInline.leaderTelephone1 = leaderTelephone[0];
          //   }
          //   if (leaderTelephone[1]) {
          //     this.formInline.leaderTelephone2 = leaderTelephone[1];
          //   }
          // if (leaderTelephone[2]) {
          //   this.formInline.leaderTelephone3 = leaderTelephone[2];
          // }
          //let leaderFax = basicInfo.leaderFax.split("-");
          //   if (leaderFax[0]) {
          //     this.formInline.leaderFax1 = leaderFax[0];
          //   }
          //   if (leaderFax[1]) {
          //     this.formInline.leaderFax2 = leaderFax[1];
          //   }
          //   if (leaderFax[2]) {
          //     this.formInline.leaderFax3 = leaderFax[2];
          //   }

          if (
            basicInfo.isInvoice === "false" ||
            basicInfo.isInvoice === "False"
          ) {
            this.isInvoice = false;
          } else {
            this.isInvoice = true;
          }
          this.formInline.invoiceTitle = basicInfo.invoiceTitle;
          this.formInline.invoiceCode = basicInfo.invoiceCode;
          this.formInline.invoiceAddress = basicInfo.invoiceAddress;
          this.formInline.invoiceTelephone = basicInfo.invoiceTelephone;
          this.formInline.invoiceBank = basicInfo.invoiceBank;
          this.formInline.invoiceBankAccount = basicInfo.invoiceBankAccount;
          this.formInline.invoiceType = basicInfo.invoiceType;
          this.formInline.PostAddr = basicInfo.postAddr;
          this.formInline.PostMan = basicInfo.postMan;
          this.formInline.PostTel = basicInfo.postTel;
        }
      }

      // 已登录的
      if (this.userId) {
        let company = await this.getJoinCompany(this.userId);
        if (company) {
          let data = await this.getCompanyBasicInfo(company.id);
          if (!data) {
            this.formInline.name = company.name;
            this.formInline.nameEn = company.nameEn;
            this.formInline.shortName = company.shortName;
            //this.formInline.creditCode = company.creditCode;
            this.formInline.country = company.country;
            //   this.formInline.province = company.province;
            //   this.formInline.city = company.city;
            //   this.formInline.county = company.county;
            this.formInline.address = company.address;
            this.formInline.website = company.website;
            this.formInline.typeAsset = company.businessType;
            this.formInline.typeBusiness = company.nature;
            this.companyId = company.id;
            //   this.change1(this.formInline.province);
            //   this.change2(this.formInline.city);
            //   this.change3(this.formInline.county);
            if (company.businessLicenses) {
              this.uploadList.push({
                name: "营业执照",
                url: company.businessLicenses,
                status: "finished",
              });
            }
            if (company.logo) {
              this.uploadList2.push({
                name: "公司logo",
                url: company.logo,
                status: "finished",
              });
            }
          } else {
            this.formInline.name = data.companyName;
            this.formInline.nameEn = data.companyNameEn;
            this.formInline.shortName = data.companyNameShort;

            this.formInline.country = data.country;

            this.formInline.address = data.address;
            this.formInline.postcode = data.postcode;
            this.formInline.telephone = data.telephone;
            this.formInline.website = data.website;
            this.formInline.typeAsset = data.typeAsset;
            this.formInline.typeBusiness = data.typeBusiness;
            let imgBusinessLicense = JSON.parse(data.imgBusinessLicense);
            let fileApplyTable = JSON.parse(data.fileApplyTable);
            //   this.change1(this.formInline.province);
            //   this.change2(this.formInline.city);
            //   this.change3(this.formInline.county);
            if (fileApplyTable && fileApplyTable.url) {
              this.uploadList5.push(fileApplyTable);
            }
            if (imgBusinessLicense && imgBusinessLicense.url) {
              this.uploadList.push(imgBusinessLicense);
            }
            let imgLogo = JSON.parse(data.imgLogo);
            if (imgLogo && imgLogo.url) {
              this.uploadList2.push(imgLogo);
            }
            if (data.isExportSales === "false") {
              this.isExport = false;
            } else {
              this.isExport = true;
            }

            if (data.isListed === "false") {
              this.isListed = false;
            } else {
              this.isListed = true;
            }
            this.formInline.stockExchange = data.listedExchange;
            this.formInline.stockCode = data.listedCode;

            if (data.isTop500 === "false") {
              this.isTop500 = false;
            } else {
              this.isTop500 = true;
            }
            this.formInline.topNo = data.topNo;

            if (data.isMicroEnterprise === "false") {
              this.isMicroEnterprise = false;
            } else {
              this.isMicroEnterprise = true;
            }

            if (data.isHighTech === "false") {
              this.isHighTech = false;
            } else {
              this.isHighTech = true;
            }

            this.formInline.linkMan = data.linkMan;
            this.formInline.linkTitle = data.linkTitle;
            this.formInline.linkMob = data.linkMob;
            this.formInline.linkEmail = data.linkEmail;

            this.formInline.leader = data.leader;
            this.formInline.leaderTitle = data.leaderTitle;
            this.formInline.leaderMob = data.leaderMob;
            this.formInline.leaderEmail = data.leaderEmail;

            console.log(data.isInvoice, "213");
            if (data.isInvoice === "false" || data.isInvoice === "False") {
              this.isInvoice = false;
            } else {
              this.isInvoice = true;
            }
            this.formInline.invoiceTitle = data.invoiceTitle;
            this.formInline.invoiceCode = data.invoiceCode;
            this.formInline.invoiceAddress = data.invoiceAddress;
            this.formInline.invoiceTelephone = data.invoiceTelephone;
            this.formInline.invoiceBank = data.invoiceBank;
            this.formInline.invoiceBankAccount = data.invoiceBankAccount;
            this.formInline.invoiceType = data.invoiceType;
            this.formInline.PostAddr = data.postAddr;
            this.formInline.PostMan = data.postMan;
            this.formInline.PostTel = data.postTel;
          }
        }
      }

      let area = await this.getAreaAll();
      if (area && area.length > 0) {
        area.map((c) => {
          c.value = c.name;
          c.label = c.name;
          c.loading = false;
          c.children = [];
        });
        this.AreaList = area;
      }

      let BusinessList = await this.getNature();
      if (BusinessList) {
        this.BusinessList = BusinessList;
      }

      let NatureList = await this.getBusinessType();
      if (NatureList) {
        this.NatureList = NatureList;
      }
    },
    async handleSubmit(name) {
      let form = this.formInline;
      console.log(this.formInline, "this.formInline");
      let valid = await this.validForm(name);
      if (!valid) {
        this.validateList = this.deteleObject(this.validateList);
        for (let i = 0; i < this.validateList.length; i++) {
          if (this.validateList[i].status == false) {
            this.ElepropName = this.validateList[i].prop;
            break;
          }
        }
        console.log(this.validateList, " this.ElepropName");
        Element.prototype.documentOffsetTop = function () {
          return (
            this.offsetTop +
            (this.offsetParent ? this.offsetParent.documentOffsetTop() : 0)
          );
        };
        let top =
          document.getElementById(this.ElepropName).documentOffsetTop() -
          window.innerHeight / 2;
        window.scrollTo(0, top);
        this.validateList = [];
        return;
      }

      // 营业执照
      let imgBusinessLicense = "";
      if (this.uploadList && this.uploadList.length) {
        imgBusinessLicense = this.uploadList[0];
      } else {
        this.$Message.error("Please upload your business license");
        return;
      }

      // logo
      let imgLogo = "";
      if (this.uploadList2 && this.uploadList2.length) {
        imgLogo = this.uploadList2[0];
      } else {
        this.$Message.error("Please upload the company logo");
        return;
      }

      //上传申请表
      let FileApplyTable = "";
      //   if (this.uploadList5 && this.uploadList5.length) {
      //     FileApplyTable = this.uploadList5[0]
      //   } else {
      //     this.$Message.error('Please Upload Application Form/请上传申请表')
      //     return
      //   }
      //   this.formInline.province = this.sheng;
      //   this.formInline.city = this.shi;
      //   this.formInline.county = this.qu;
      // 是否为外销企业
      //   let exportSalesArea = "";
      let exportSalesCountry = "";
      let hasExportSalesArea = false;
      if (this.isExport) {
        if (
          this.formInline.exportSalesArea &&
          this.formInline.exportSalesArea.length > 0
        ) {
          this.formInline.exportSalesArea.map((c, i) => {
            if (c.length) {
              hasExportSalesArea = true;
              if (exportSalesArea.indexOf(c[0]) === -1) {
                if (i !== this.formInline.exportSalesArea.length - 1) {
                  exportSalesArea += c[0] + ",";
                } else {
                  exportSalesArea += c[0];
                }
              }
            }
          });
        }
        // if (!hasExportSalesArea) {
        //   this.$Message.error("请选择洲-国家");
        //   return;
        // }
        // exportSalesCountry = JSON.stringify(this.formInline.exportSalesArea);
      }

      // 是否上市
      if (this.isListed) {
        if (!this.formInline.stockExchange) {
          this.$Message.error(
            "Please enter securities exchange/请输入证件交易所"
          );
          return;
        }
        if (!this.formInline.stockCode) {
          this.$Message.error("Please enter stock ticker/请输入股票代码");
          return;
        }
      }

      // 是否500
      if (this.isTop500) {
        if (!this.formInline.topNo) {
          this.$Message.error("Please enter ranking/请输入排名");
          return;
        }
      }

      // 小微企业证明
      // let imgMicroEnterprise = "";
      // if (this.isMicroEnterprise) {
      //   if (this.uploadList3 && this.uploadList3.length) {
      //     imgMicroEnterprise = this.uploadList3;
      //   } else {
      //     this.$Message.error("Please upload proof of small and micro enterprise");
      //     return;
      //   }
      // } else {
      //   imgMicroEnterprise = "";
      // }

      // 高新技术企业
      // let imgHighTech = "";
      // if (this.isHighTech) {
      //   if (this.uploadList4 && this.uploadList4.length) {
      //     imgHighTech = this.uploadList4;
      //   } else {
      //     this.$Message.error("Please upload high-tech enterprises");
      //     return;
      //   }
      // } else {
      //   imgHighTech = "";
      // }

      //   if (
      //     !this.formInline.linkTelephone1 &&
      //     !this.formInline.linkTelephone2
      //   ) {
      //     this.$Message.error("Please enter Contact Person Telephone");
      //     return;
      //   }
      // 展会联系人电话
      let linkTelephone = "";
      //   if (this.formInline.linkTelephone1) {
      //     linkTelephone = this.formInline.linkTelephone1;
      //     if (this.formInline.linkTelephone2) {
      //       linkTelephone += "-" + this.formInline.linkTelephone2;
      //     }
      //     if (this.formInline.linkTelephone3) {
      //       linkTelephone += "-" + this.formInline.linkTelephone3;
      //     }
      //   } else {
      //     if (this.formInline.linkTelephone2) {
      //       linkTelephone = this.formInline.linkTelephone2;
      //       if (this.formInline.linkTelephone3) {
      //         linkTelephone += "-" + this.formInline.linkTelephone3;
      //       }
      //     } else {
      //       linkTelephone = this.formInline.linkTelephone3;
      //     }
      //   }
      // 展会联系人传真
      //   let linkFax = "";
      //   if (this.formInline.linkFax1) {
      //     linkFax = this.formInline.linkFax1;
      //     if (this.formInline.linkFax2) {
      //       linkFax += "-" + this.formInline.linkFax2;
      //     }
      //     if (this.formInline.linkFax3) {
      //       linkFax += "-" + this.formInline.linkFax3;
      //     }
      //   } else {
      //     if (this.formInline.linkFax2) {
      //       linkFax = this.formInline.linkFax2;
      //       if (this.formInline.linkFax3) {
      //         linkFax += "-" + this.formInline.linkFax3;
      //       }
      //     } else {
      //       linkFax = this.formInline.linkFax3;
      //     }
      //   }

      //   if (
      //     !this.formInline.leaderTelephone1 &&
      //     !this.formInline.leaderTelephone2
      //   ) {
      //     this.$Message.error("Please enter市场部负责人电话");
      //     return;
      //   }
      // 市场部负责人电话
      //   let leaderTelephone = "";
      //   if (this.formInline.leaderTelephone1) {
      //     leaderTelephone = this.formInline.leaderTelephone1;
      //     if (this.formInline.leaderTelephone2) {
      //       leaderTelephone += "-" + this.formInline.leaderTelephone2;
      //     }
      //     // if (this.formInline.leaderTelephone3) {
      //     //   leaderTelephone += "-" + this.formInline.leaderTelephone3;
      //     // }
      //   } else {
      //     if (this.formInline.leaderTelephone2) {
      //       leaderTelephone = this.formInline.leaderTelephone2;
      //       // if (this.formInline.leaderTelephone3) {
      //       //   leaderTelephone += "-" + this.formInline.leaderTelephone3;
      //       // }
      //     } else {
      //       // leaderTelephone = this.formInline.leaderTelephone3;
      //     }
      //   }
      // 市场部负责人传真
      //   let leaderFax = "";
      //   if (this.formInline.leaderFax1) {
      //     leaderFax = this.formInline.leaderFax1;
      //     if (this.formInline.leaderFax2) {
      //       leaderFax += "-" + this.formInline.leaderFax2;
      //     }
      //     if (this.formInline.leaderFax3) {
      //       leaderFax += "-" + this.formInline.leaderFax3;
      //     }
      //   } else {
      //     if (this.formInline.leaderFax2) {
      //       leaderFax = this.formInline.leaderFax2;
      //       if (this.formInline.leaderFax3) {
      //         leaderFax += "-" + this.formInline.leaderFax3;
      //       }
      //     } else {
      //       leaderFax = this.formInline.leaderFax3;
      //     }
      //   }

      // 有/无开票信息
      let invoiceTitle = "";
      let invoiceCode = "";
      let invoiceAddress = "";
      let invoiceTelephone = "";
      let invoiceBank = "";
      let invoiceBankAccount = "";
      let invoiceType = "";
      let postAddr = "";
      let postMan = "";
      let postTel = "";
      if (!this.isInvoice) {
        invoiceTitle = this.formInline.invoiceTitle;
        invoiceCode = this.formInline.invoiceCode;
        invoiceAddress = this.formInline.invoiceAddress;
        invoiceTelephone = this.formInline.invoiceTelephone;
        invoiceBank = this.formInline.invoiceBank;
        invoiceBankAccount = this.formInline.invoiceBankAccount;
        invoiceType = this.formInline.invoiceType;
        postAddr = this.formInline.PostAddr;
        postMan = this.formInline.PostMan;
        postTel = this.formInline.PostTel;
      } else {
        invoiceTitle = "";
        invoiceCode = "";
        invoiceAddress = "";
        invoiceTelephone = "";
        invoiceBank = "";
        invoiceBankAccount = "";
        invoiceType = "";
        postAddr = "";
        postMan = "";
        postTel = "";
      }

      let req = {
        companyName: this.formInline.name,
        companyNameEn: this.formInline.nameEn,
        companyId: this.companyId,
        companyNameShort: this.formInline.shortName,
        //unifiedCode: this.formInline.creditCode, // 统一社会信用代码
        country: this.formInline.country,
        // province: this.formInline.province,
        // city: this.formInline.city,
        // county: this.formInline.county,
        address: this.formInline.address,
        postcode: this.formInline.postcode,
        telephone: this.formInline.telephone,
        website: this.formInline.website,
        typeAsset: this.formInline.typeAsset,
        typeBusiness: this.formInline.typeBusiness,
        imgBusinessLicense: JSON.stringify(imgBusinessLicense),
        imgLogo: JSON.stringify(imgLogo),
        isExportSales: this.isExport, // 是否外销
        //exportSalesArea: exportSalesArea,
        exportSalesCountry: exportSalesCountry,
        isListed: this.isListed, // 是否上市
        listedExchange: this.formInline.stockExchange, // 证件交易所
        listedCode: this.formInline.stockCode, // 股票代码
        isTop500: this.isTop500, // 是否500
        topNo: this.formInline.topNo,
        isMicroEnterprise: this.isMicroEnterprise, // 是否为小微企业
        //imgMicroEnterprise: JSON.stringify(imgMicroEnterprise),
        isHighTech: this.isHighTech, // 是否为高新技术企业
        //imgHighTech: JSON.stringify(imgHighTech),
        linkMan: this.formInline.linkMan,
        linkTitle: this.formInline.linkTitle,
        linkMob: this.formInline.linkMob,
        linkEmail: this.formInline.linkEmail,
        linkTelephone: linkTelephone,
        // linkFax: linkFax,
        leader: this.formInline.leader,
        leaderTitle: this.formInline.leaderTitle,
        leaderMob: this.formInline.leaderMob,
        leaderEmail: this.formInline.leaderEmail,
        //leaderTelephone: leaderTelephone,
        //leaderFax: leaderFax,
        isInvoice: this.isInvoice,
        invoiceTitle: invoiceTitle,
        invoiceCode: invoiceCode,
        invoiceAddress: invoiceAddress,
        invoiceTelephone: invoiceTelephone,
        invoiceBank: invoiceBank,
        invoiceBankAccount: invoiceBankAccount,
        invoiceType: invoiceType,
        postAddr: postAddr,
        postMan: postMan,
        postTel: postTel,
        FileApplyTable: JSON.stringify(FileApplyTable),
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      if (this.basicInfo) {
        let opt = {
          id: this.basicInfo.id,
          setValues: {
            CompanyName: this.formInline.name,
            CompanyNameEn: this.formInline.nameEn,
            CompanyId: this.companyId,
            CompanyNameShort: this.formInline.shortName,
            //unifiedCode: this.formInline.creditCode, // 统一社会信用代码
            Country: this.formInline.country,
            // province: this.formInline.province,
            // city: this.formInline.city,
            // county: this.formInline.county,
            Address: this.formInline.address,
            Postcode: this.formInline.postcode,
            Telephone: this.formInline.telephone,
            Website: this.formInline.website,
            TypeAsset: this.formInline.typeAsset,
            TypeBusiness: this.formInline.typeBusiness,
            imgBusinessLicense: JSON.stringify(imgBusinessLicense),
            ImgLogo: JSON.stringify(imgLogo),
            IsExportSales: this.isExport, // 是否外销
            //exportSalesArea: exportSalesArea,
            ExportSalesCountry: exportSalesCountry,
            IsListed: this.isListed, // 是否上市
            ListedExchange: this.formInline.stockExchange, // 证件交易所
            ListedCode: this.formInline.stockCode, // 股票代码
            IsTop500: this.isTop500, // 是否500
            TopNo: this.formInline.topNo,
            IsMicroEnterprise: this.isMicroEnterprise, // 是否为小微企业
            //imgMicroEnterprise: JSON.stringify(imgMicroEnterprise),
            IsHighTech: this.isHighTech, // 是否为高新技术企业
            //imgHighTech: JSON.stringify(imgHighTech),
            LinkMan: this.formInline.linkMan,
            LinkTitle: this.formInline.linkTitle,
            LinkMob: this.formInline.linkMob,
            LinkEmail: this.formInline.linkEmail,
            LinkTelephone: linkTelephone,
            // linkFax: linkFax,
            Leader: this.formInline.leader,
            LeaderTitle: this.formInline.leaderTitle,
            LeaderMob: this.formInline.leaderMob,
            LeaderEmail: this.formInline.leaderEmail,
            //leaderTelephone: leaderTelephone,
            //leaderFax: leaderFax,
            IsInvoice: this.isInvoice,
            InvoiceTitle: invoiceTitle,
            InvoiceCode: invoiceCode,
            InvoiceAddress: invoiceAddress,
            InvoiceTelephone: invoiceTelephone,
            InvoiceBank: invoiceBank,
            InvoiceBankAccount: invoiceBankAccount,
            InvoiceType: invoiceType,
            PostAddr: postAddr,
            PostMan: postMan,
            PostTel: postTel,
            FileApplyTable: JSON.stringify(FileApplyTable),
          },
        };
        let bool = await this.editApplyCompany(JSON.stringify(opt));
        this.loading = false;
        if (bool && bool.successed) {
          this.$Message.success("Modificated Successfully!/修改成功！");

          if (this.applyCompanyOrderId) {
            // this.$router.push("/join/entrance?applyCompanyId=" + this.applyCompanyId+ "&applyCompanyOrderId=" + this.applyCompanyOrderId);
            this.$router.push(
              "/join/applicationEn?id=" +
                this.upDateExId +
                "&applyCompanyId=" +
                this.applyCompanyId +
                "&applyCompanyOrderId=" +
                this.applyCompanyOrderId
            );
          } else {
            this.$router.push(
              "/join/entranceEn?applyCompanyId=" + this.applyCompanyId
            );
          }
        }
      } else {
        let bool = await this.addApplyCompany(JSON.stringify(req));
        this.loading = false;
        if (bool && bool.successed) {
          this.$Message.success("Submit succeeded!/提交成功!");
          this.$router.push("/join/entranceEn?applyCompanyId=" + bool.info);
        }
      }
    },
    async loadData(item, callback) {
      item.loading = true;
      let list = await this.getCountryByArea(item.name);
      if (list && list.length > 0) {
        list.map((c) => {
          c.label = c.name;
          c.value = c.name;
        });
        item.children = list;
      } else {
        this.$Message.warning("No more/没有更多了");
      }
      item.loading = false;
      callback();
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          console.log(valid, "valid");
          resolve(valid);
        });
      });
    },

    listedChange(e) {
      if (!e) {
        this.formInline.stockExchange = "";
        this.formInline.stockCode = "";
      }
    },
    topNoChange(e) {
      if (!e) {
        this.formInline.topNo = "";
      }
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList.push({
          name: this.uploadName,
          url: res.list[0],
          status: "finished",
        });
      } else {
        this.uploadName = "";
      }
    },
    handleFormatError(file) {
      this.uploadName = "";
      this.$Notice.warning({
        title: "Incorrect file format/文件格式是不正确的",
        desc: "Please upload image of JPG/PNG/请上传jpg或者png格式的图片",
      });
    },
    handleMaxSize(file) {
      this.uploadName = "";
      this.$Notice.warning({
        title: "File size exceeded the limit/文件大小超过限制",
        desc: "Please upload an image within 2M/请上传小于2M的图片",
      });
    },
    handleBeforeUpload(e) {
      this.uploadName = e.name;
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `Upload up to${limitNum} picture`,
        });
      }
      return check;
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess2(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList2.push({
          name: this.uploadName2,
          url: res.list[0],
          status: "finished",
        });
      } else {
        this.uploadName2 = "";
      }
    },
    handleFormatError2(file) {
      this.uploadName2 = "";
      this.$Notice.warning({
        title: "Incorrect file format/文件格式是不正确的",
        desc: "Please upload image of JPG/PNG/请上传jpg或者png格式的图片",
      });
    },

    handleMaxSize2(file) {
      this.uploadName2 = "";
      this.$Notice.warning({
        title: "File size exceeded the limit/文件大小超过限制",
        desc: "Please upload an image within 2M/请上传小于2M的图片",
      });
    },
    handleBeforeUpload2(e) {
      this.uploadName2 = e.name;
      const limitNum = 1;
      const check = this.uploadList2.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `Upload up to${limitNum} picture`,
        });
      }
      return check;
    },
    handleRemoveByArr2(file) {
      const fileList = this.uploadList2;
      this.uploadList2.splice(fileList.indexOf(file), 1);
    },
    handleSuccess3(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList3.push({
          name: this.uploadName3,
          url: res.list[0],
          status: "finished",
        });
      } else {
        this.uploadName3 = "";
      }
    },
    handleFormatError3(file) {
      this.uploadName3 = "";
      this.$Notice.warning({
        title: "Incorrect file format/文件格式是不正确的",
        desc: "Please upload image of JPG/PNG/请上传jpg或者png格式的图片",
      });
    },
    handleMaxSize3(file) {
      this.uploadName3 = "";
      this.$Notice.warning({
        title: "File size exceeded the limit/文件大小超过限制",
        desc: "Please upload an image within 2M/请上传小于2M的图片",
      });
    },
    handleBeforeUpload3(e) {
      this.uploadName3 = e.name;
      const limitNum = 5;
      const check = this.uploadList3.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `Upload up to${limitNum} picture`,
        });
      }
      return check;
    },
    handleRemoveByArr3(file) {
      const fileList = this.uploadList3;
      this.uploadList3.splice(fileList.indexOf(file), 1);
    },
    handleSuccess4(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList4.push({
          name: this.uploadName4,
          url: res.list[0],
          status: "finished",
        });
      } else {
        this.uploadName4 = "";
      }
    },
    handleFormatError4(file) {
      this.uploadName4 = "";
      this.$Notice.warning({
        title: "Incorrect file format/文件格式是不正确的",
        desc: "Please upload image of JPG/PNG/请上传jpg或者png格式的图片",
      });
    },
    handleMaxSize4(file) {
      this.uploadName4 = "";
      this.$Notice.warning({
        title: "File size exceeded the limit/文件大小超过限制",
        desc: "Please upload an image within 2M/请上传小于2M的图片",
      });
    },
    handleBeforeUpload4(e) {
      this.uploadName4 = e.name;
      const limitNum = 5;
      const check = this.uploadList4.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `Upload up to${limitNum} picture`,
        });
      }
      return check;
    },
    handleRemoveByArr4(file) {
      const fileList = this.uploadList4;
      this.uploadList4.splice(fileList.indexOf(file), 1);
    },
    handleSuccess5(res, file) {
      console.log(res, "ressssssssss");
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList5.push({
          name: this.uploadName5,
          url: res.list[0],
          status: "finished",
        });
      } else {
        this.uploadName4 = "";
      }
    },
    handleFormatError5(file) {
      this.uploadName4 = "";
      this.$Notice.warning({
        title: "Incorrect file format/文件格式是不正确的",
        desc: "Please upload a PDF/请上传pdf文件",
      });
    },
    handleMaxSize5(file) {
      this.uploadName5 = "";
      this.$Notice.warning({
        title: "File size exceeded the limit/文件大小超过限制",
        desc: "Please upload an image within 2M/请上传小于2M的文件",
        duration: 0,
      });
    },
    handleBeforeUpload5(e) {
      console.log(e, "eeeeeeeeee");
      this.uploadName5 = e.name;
      const limitNum = 1;
      const check = this.uploadList5.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `Upload up to${limitNum} File`,
        });
      }
      return check;
    },
    handleRemoveByArr5(file) {
      const fileList = this.uploadList5;
      this.uploadList5.splice(fileList.indexOf(file), 1);
    },
    // addAreaArr() {
    //   if (this.formInline.exportSalesArea.length > 4) {
    //     this.$Message.warning("5 pictures at most");
    //     return;
    //   }
    //   this.formInline.exportSalesArea.push([]);
    // },
    // delAreaArr(i) {
    //   this.formInline.exportSalesArea.splice(i, 1);
    // },
    //点击省得到id找出对应的市

    change1(val) {
      console.log(this.formInline.province);
      this.cityList2 = [];
      // this.formInline.city = "",//清空
      // this.formInline.county = ""//清空

      this.sheng = val; //为得到县储存值
      var city = this.city;
      for (var i in city) {
        if (val == city[i].name) {
          this.sheng = city[i].name;
          var shi = city[i].child;
          for (var j in shi) {
            var obj = {
              value: shi[j].name,
              id: shi[j].id,
            };

            this.cityList2.push(obj);
          }
        }
      }
    },
    //改变市获取区县
    change2(val2) {
      console.log(val2);
      this.cityList3 = [];
      // this.formInline.county = ""//清空

      var val = this.sheng;

      var city = this.city;
      for (var i in city) {
        var shi = city[i].child;
        for (var j in shi) {
          if (val2 == shi[j].name) {
            var qu = shi[j].child;
            console.log(qu);
            this.shi = shi[j].name;
            for (var k in qu) {
              var obj = {
                value: qu[k].name,
                id: qu[k].id,
              };
              this.cityList3.push(obj);
            }
          }
        }
      }
    },
    change3(val3) {
      console.log(val3, "val3");
      this.model3 = val3;

      var city = this.city;
      for (var i in city) {
        var shi = city[i].child;
        for (var j in shi) {
          var qu = shi[j].child;
          for (var k in qu) {
            if (val3 == qu[k].name) {
              this.qu = qu[k].name;

              console.log(this.sheng, this.shi, this.qu, "省市区");
            }
          }
        }
      }
    },
    // 下载申请表
    async getfile() {
      let data1 = await this.getApplyConfig();
      console.log(data1, "data11121111");
      let key1 = data1.fileApplyTableEn;
      let opt = {
        key: key1,
        name: data1.fileApplyTableEnName,
      };
      //   let data = await this.getwordfileEn(opt);
      this.downloadUrl(key1);
    },
    downloadUrl(url) {
      // console.log(url);
      let link = document.createElement("a");
      //创建一个a标签
      link.style.display = "none";
      //将a标签隐藏
      link.href = url;
      //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
      link.setAttribute("download", name);
      // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
      document.body.appendChild(link);
      //将上面创建的a标签加入到body的尾部
      link.click();
      //执行a标签
    },
    //资产类型选择框变更
    getselect(value) {
      if (value.trim() == "Others") {
        this.isOption = false;
      } else {
        this.isOption = true;
      }
    },
    //选择发票类型
    changeInvoice(value) {
      console.log(value, "shihjfgodrjodrjgoirj");
    },
    //同上按钮
    ditto() {
      this.formInline.leader = this.formInline.linkMan;
      this.formInline.leaderTitle = this.formInline.linkTitle;
      this.formInline.leaderMob = this.formInline.linkMob;
      this.formInline.leaderEmail = this.formInline.linkEmail;
    },
  },

  created() {
    this.init();
  },
};
</script>

<style scoped lang='scss'>
.req {
  display: flex;
  align-items: center;
  margin-right: 10px;
  line-height: 1;
  font-family: SimSun;
  font-size: 14px;
  color: #ed4014;
}

.basic {
  &-task {
    width: 100%;
    margin: 20px 0 50px;
    padding: 0 80px;
    display: flex;
    justify-content: space-between;
    color: #666;
    position: relative;

    .task-one {
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 2;

      .box {
        width: 20px;
        height: 20px;
        background-color: #fff;
        box-shadow: 0px 2px 5px 0px #00bdca59;
        border-radius: 50%;
        margin-top: 10px;

        div {
          width: 14px;
          height: 14px;
          background-color: #8ba5bc;
          border-radius: 50%;
          margin: 3px auto 0;
        }
      }
    }

    .line {
      height: 8px;
      background-color: #d7e2e4;
      position: absolute;
      width: 998px;
      left: 108px;
      top: 37px;
      z-index: 1;
    }

    .ing {
      color: #00bdca;

      .box {
        div {
          background-color: #00bdca;
        }
      }
    }

    .finished {
      color: #00bdca;

      .box {
        background-color: #00bdca;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-color: #00bdca;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      line-height: 64px;
      font-size: 20px;
    }

    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-name {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-address {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-phone {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-license {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  .upload-btn {
    width: 240px;
    height: 32px;
    background-color: #fff;
    text-align: center;
    cursor: pointer;
  }

  .license-img {
    display: flex;
    flex-wrap: wrap;

    &-list {
      line-height: 32px;
      padding: 0 10px;
      background-color: #fff;
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 10px;

      span {
        color: #db2a4b;
        cursor: pointer;
      }

      .line {
        width: 1px;
        height: 24px;
        background-color: #e6e6e6;
        margin: 0 6px;
      }
    }
  }

  &-export {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-scale {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-tech {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-link {
    padding: 0 30px;
    background-color: #ededed;

    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;

      ::v-deep .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }
  }

  &-links {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-leader {
    padding: 0 30px;
    background-color: #ededed;
    position: relative;

    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;

      ::v-deep .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }

    .above {
      position: absolute;
      left: 350px;
      top: 10px;
    }
  }

  &-leaders {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-invoiceType {
    padding: 0 30px;
    background-color: #ededed;
    line-height: 48px;
    display: flex;
    justify-content: space-between;

    .ivu-checkbox-wrapper {
      margin: 0;
    }

    span {
      color: #db2a4b;
      margin-left: 5px;
    }
  }

  &-invoices {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-btn {
    margin-top: 50px;
    margin-bottom: 80px;
    text-align: center;

    button {
      width: 200px;
      height: 48px;
      background-color: #db2a4b;
      font-size: 16px;
      border-color: #db2a4b;
    }
  }

  .downLoad {
    display: flex;
    align-items: center;
    margin-left: 20px;
  }
}
</style>
